import $ from 'jquery';
import { Functions } from '../helpers';

export class PurchaseOrderForm {

	constructor(App) {
        PurchaseOrderForm.App = App;
        PurchaseOrderForm.UI = App.PwnUI;
        PurchaseOrderForm.settings = App.settings;
        this.$purchaseForm = $('form.woocommerce-checkout');
        this.initialize();
	};

	initialize() {
       if (!this.$purchaseForm.length) return;

       console.log('test :: PurchaseOrderForm')

        this.$purchaseForm.on('blur', 'input[name="billing_maximum_bid"]', this.triggerCheckoutUpdate.bind(this));
        this.$purchaseForm.on('change', 'input[name="billing_security_deposit"]', this.triggerCheckoutUpdate.bind(this));
	};

    triggerCheckoutUpdate(e) {
        console.log('triggerCheckoutUpdate')

        $(document.body).trigger('update_checkout');
    };
}
